<template>
  <Modal position="end" ref="modalRef" frameless-body>
    <template #header>Conversation</template>
    <template #body>
      <template v-if="conversation.isLoaded">
        <View direction="row" gap="md" padding="md" align="center" class="property-info" v-if="activeInquiry">
          <PropertyPhotoPreview :image-url="activeInquiry.property.coverImage" size="xs" />
          <Text variant="label-medium" color="primary">
            {{ activeInquiry.property.displayName }}
          </Text>
        </View>

        <View padding="lg">
          <ConversationTranscript :conversation="conversation.conversation!" />
        </View>
      </template>

      <View v-else justify="center" padding="xl">
        <LoadingIndicator />
      </View>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { Modal, View, Text, LoadingIndicator } from '@tallo/design-system';
import { ConversationTranscript } from '@tallo/investor/conversation';
import { PropertyPhotoPreview } from '@tallo/property';

import { useRenterProfileStore } from '../store/renter-profile.store';

const renterProfileStore = useRenterProfileStore();
const modalRef = ref<InstanceType<typeof Modal>>();

const conversation = computed(() => renterProfileStore.getActiveConversation);
const activeInquiry = computed(() => renterProfileStore.getActiveInquiry);

defineExpose({ modalRef });
</script>

<style scoped lang="scss">
.property-info {
  padding-left: var(--t-spacing-lg);
  border-bottom: 1px solid var(--t-color-neutral-200);
}
</style>
